<p-floatLabel>
  <p-select #operatorStateDropdown
            id="operatorDropdown"
            name="operatorDropdown"
            [options]="operatorStates"
            [(ngModel)]="operatorState"
            [showClear]="!isRequired"
            [checkmark]="true"
            styleClass="w-100"
            (onChange)="onSelected()">
    <ng-template let-option pTemplate="item">
      {{ option.label }}
    </ng-template>
  </p-select>
  <label for="operatorDropdown">
    <app-label-content [isRequired]="isRequired">
      {{ l('::State') }}
    </app-label-content>
  </label>
</p-floatLabel>
